import { useDispatch, useSelector } from "react-redux";
import { CompanyActions } from "../../store/company_dtl";
import { EMenuActions } from "../../store";
import { UserActions } from "../../store/user";
import { useLocation } from "react-router-dom";
import { useState } from "react";

export default function Indoor() {
  let dispatch = useDispatch();

  const table = useSelector((state) => state.Company.tableNo);
  console.log(table)
  const waiterScreen = useLocation().pathname.split("/")[2];
  const [searchTerm, setSearchTerm] = useState("")
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const userName = useSelector((state) => state.User.userName);
  const userEmail = useSelector((state) => state.User.userEmail);
  const userPhone = useSelector((state) => state.User.userPhone);
  const userExist = useSelector((state) => state.User.userAddress);
  const available_table = useSelector((state) => state.Company.available_table);
  console.log(available_table)
  const indoor_selected_value = useSelector(
    (state) => state.EMenu.indoor_selected_value
  );
  const filteredTables = available_table?.filter((table) =>
    table.TableNo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSltd_TB = (value, text) => {
    console.log('fff')
    dispatch(CompanyActions.setSL_TB(text));
    dispatch(CompanyActions.setSL_TB_ID(value));
  };

  const handleSelected = (e) => {
    dispatch(EMenuActions.setIndoorSelected(e.target.value));
  };

  const handleUserEmail = (e) => {
    dispatch(UserActions.setUserEmail(e.target.value));
  };
  return (
    <div className="w-[100%] m-auto my-5">
      <div className="flex flex-col gap-4">
        <div className="flex flex-row gap-3">
          <input
            type="radio"
            value={"unpaid"}
            checked={indoor_selected_value === "unpaid"}
            onChange={handleSelected}
            className="w-4 h-4"
          />
          <p>Place Order</p>
        </div>
        <div className="flex flex-row gap-3">
          <input
            type="radio"
            value={"paid"}
            checked={indoor_selected_value === "paid"}
            onChange={handleSelected}
            className="w-4 h-4"
          />
          <p>Pay Now & Place Order</p>
        </div>
      </div>
      {indoor_selected_value === "unpaid" && (
        <div className={`w-[100%] m-auto my-5 `}>
          <div className={`${waiterScreen === "waiterscreen" && "hidden"}`}>
            <label className="text-sm font-bold ">Full Name</label>
            <input
              value={userName}
              type="text"
              name="name"
              onChange={(e) =>
                dispatch(UserActions.setUserName(e.target.value))
              }
              className={`${userExist === true ? "disable" : null
                } w-[100%] mt-2 mb-2 max-sm:mb-5 border border-dark/30 rounded-md py-2 px-3 outline-none`}
            />

            <div className="grid grid-cols-2 gap-5">
              <div className="flex flex-col">
                <label className="text-sm font-bold ">Email Address</label>
                <input
                  value={userEmail}
                  type="emailaddress"
                  name="email"
                  onChange={handleUserEmail}
                  className="w-[100%] mt-2 mb-2 max-sm:mb-5 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
                />
              </div>

              <div className="flex flex-col">
                <label className="text-sm font-bold ">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={userPhone}
                  autoComplete="on"
                  onChange={(e) =>
                    dispatch(UserActions.setUserPhone(e.target.value))
                  }
                  className="w-[100%] mt-2 mb-2 max-sm:mb-5 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
                />
              </div>
            </div>
          </div>
          <div className="mt-4">
            {waiterScreen === 'tablemenu' ? (
              <div className="relative border-2 border-dark/30 p-4 rounded-md bg-gray-200 cursor-not-allowed">
              <p className="text-sm text-gray-600">{table || "--Table not set--"}</p>
            </div>
            ):
            <div>
            <label className=" font-bold text-sm">
              Kindly select your table number
            </label>

            <div
              className="relative border-2 border-dark/30 p-4 rounded-md cursor-pointer"
              onClick={() => {
                setIsDropdownOpen(!isDropdownOpen)
              }}
            >
              <p className="text-sm text-gray-600">
                {searchTerm || "--Select a table--"}
              </p>
            </div>
            </div>
          
          }
            

            {/* Dropdown Content */}
            {isDropdownOpen && (
              <div className="z-50  bg-white border border-dark/30 rounded-md mt-2 w-full shadow-lg">
                {/* Search Input */}
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full p-2 border-b border-dark/30 outline-none"
                  placeholder="Search tables..."
                />

                <div className="max-h-48 overflow-y-scroll">
                  {filteredTables.length > 0 ? (
                    filteredTables.map((table) => (
                      <div
                        key={table.id}
                        onClick={() => {
                          handleSltd_TB({ target: { value: table.id } });
                          handleSltd_TB(table.id, table.TableNo);
                          setSearchTerm(table.TableNo); // Set selected value
                          setIsDropdownOpen(false); // Close dropdown
                        }}
                        className="p-3 hover:bg-dark/10 cursor-pointer"
                      >
                        {table.TableNo}
                      </div>
                    ))
                  )
                    : (
                      <input
                        type="text"
                        value={table}
                        // onChange={(e) => dispatch(UserActions.setUserPhone(e.target.value))}
                        className="w-[100%] mt-2 mb-2 max-sm:mb-5 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
                        onClick={handleSltd_TB}
                        disabled
                      />

                    )}
                </div>
              </div>

            )}
            {indoor_selected_value === "paid" && (
              <div className={` w-[100%] m-auto my-5`}>
                <div className={`${waiterScreen === "waiterscreen" && "hidden"}`}>
                  <label className="text-sm font-bold ">Full Name</label>
                  <input
                    value={userName}
                    type="text"
                    name="name"
                    onChange={(e) =>
                      dispatch(UserActions.setUserName(e.target.value))
                    }
                    className={`${userExist === true ? "disable" : null
                      } w-[100%] mt-2 mb-2 max-sm:mb-5 border border-dark/30 rounded-md py-2 px-3 outline-none`}
                  />

                  <div className="grid grid-cols-2 gap-5">
                    <div className="flex flex-col">
                      <label className="text-sm font-bold ">Email Address</label>
                      <input
                        value={userEmail}
                        type="emailaddress"
                        name="email"
                        onChange={handleUserEmail}
                        className="w-[100%] mt-2 mb-2 max-sm:mb-5 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
                        required={true}
                      />
                    </div>

                    <div className="flex flex-col">
                      <label className="text-sm font-bold ">Phone Number</label>
                      <input
                        type="tel"
                        value={userPhone}
                        autoComplete="on"
                        onChange={(e) =>
                          dispatch(UserActions.setUserPhone(e.target.value))
                        }
                        className="w-[100%] mt-2 mb-2 max-sm:mb-5 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                {waiterScreen === 'tablemenu' ? (
              <div className="relative border-2 border-dark/30 p-4 rounded-md bg-gray-200 cursor-not-allowed">
              <p className="text-sm text-gray-600">{table || "--Table not set--"}</p>
            </div>
            ):
            <div>
            <label className=" font-bold text-sm">
              Kindly select your table number
            </label>

            <div
              className="relative border-2 border-dark/30 p-4 rounded-md cursor-pointer"
              onClick={() => {
                setIsDropdownOpen(!isDropdownOpen)
              }}
            >
              <p className="text-sm text-gray-600">
                {searchTerm || "--Select a table--"}
              </p>
            </div>
            </div>
          
          }
                  <label className=" font-bold text-sm">
                    Kindly select your table number
                  </label>
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full border-2 border-dark/30 p-2 rounded-md mb-3"
                    placeholder="Search tables..."
                  />
                  {available_table? (
                    
                    <select
                      onChange={handleSltd_TB}
                      className="w-[100%] border-2 border-dark/30 p-4 rounded-md mt-3 mb-5"
                    >
                      <option key={0} value={"undefined"}>
                        --Select a table
                      </option>
                      {available_table?.length &&
                        available_table?.map((table) => (
                          <option key={table.id} value={table.id} id={table.Capacity}>
                            {table.TableNo}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      value={table}
                      className="w-[100%] mt-2 mb-2 max-sm:mb-5 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
                      onChange={handleSltd_TB}
                      
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
